import { useTranslation } from 'react-i18next'

import * as H from 'hooks'
import * as U from 'utils'
import DashboardCard, { TextColor } from '../DashboardCard/DashboardCard'

import { CLASS_NAME } from './const'
import { type Emissions } from 'types/data'

import '../style.scss'

type Props = {
  emissions: Emissions[]
  year: number
  className?: string
}

export default function NEEIntensity({
  emissions,
  year,
  className
}: Props): JSX.Element {
  const { t } = useTranslation()
  const finalClassName = H.useClassName(CLASS_NAME, className)

  // Calculate total area as in TotalArea card (deduped by feature_uuid)
  const dedupedPolygons = Array.from(
    new Map(
      (emissions ?? []).map((polygon) => [
        polygon.feature.properties.feature_uuid,
        {
          area: polygon.feature.properties.area
        }
      ])
    ).values()
  )

  const totalArea = dedupedPolygons == null
    ? 0
    : (dedupedPolygons as Array<{ area: number }>).reduce(
        (sum, { area }) => sum + (area ?? 0),
        0
      )

  // Use the same NEE total as NEETotal card
  const total = U.getEmissionsTotalForYear(emissions, year)

  // Intensity = total / area
  const totalIntensity = totalArea === 0 ? 0 : total / totalArea
  const finalValue = U.getFormattedEmissionsValue(totalIntensity, true)
  const getTextColor = (): TextColor | undefined => {
    if (total > 0) return TextColor.Red
    if (total < 0) return TextColor.Green
  }

  return (
    <DashboardCard
      title={t('metric_card_relative_flux.title')}
      tooltipText={t('metric_card_relative_flux.tooltip')}
      value={finalValue}
      textColor={getTextColor()}
      className={finalClassName}
    />
  )
}

export { CLASS_NAME }
